import React, { useEffect, useState } from 'react';

type Props = {
    pagerConf: any;
    changePage: Function;
    refresh?: Function
};
const Pagger = (props: Props) => {
    const [start, setStart] = useState<number>(0);
    const [end, setEnd] = useState<number>(0);
    const [currentPage, setCurrentPage] = useState<number>(0);
    const [pageNumber, setPageNumber] = useState<number>(0);
    const [totalPages, setTotalPages] = useState<number>(0);

    useEffect(() => {
        const started = (props.pagerConf.currentPage - 1) * props.pagerConf.pageSize + 1;
        let end = started + props.pagerConf.pageSize - 1;
        if (end > props.pagerConf.totalItems) {
            end = props.pagerConf.totalItems;
        }
        let totalPages = props.pagerConf.totalItems / props.pagerConf.pageSize;
        const t = props.pagerConf.totalItems % props.pagerConf.pageSize;
        if (t > 0) {
            totalPages++;
        }
        setTotalPages(parseInt(totalPages.toString()));
        setCurrentPage(props.pagerConf.currentPage);
        setPageNumber(props.pagerConf.currentPage)
        setStart(started);
        setEnd(end);

    }, [props.pagerConf, props.pagerConf.currentPage, props.pagerConf.totalItems]);

    const onGoToFirstClick = (e: any) => {
        console.log('onGoToFirstClick');
        props.changePage(1);
    }
    const onGoToLastClick = (e: any) => {
        console.log('onGoToLastClick');
        props.changePage(totalPages);
    }
    const onPrevClick = (e: any) => {
        console.log('onPrevClick');
        if (currentPage > 1) {
            props.changePage(currentPage - 1);
        }
    }
    const onNextClick = (e: any) => {
        console.log('onNextClick');
        if (currentPage < totalPages) {
            props.changePage(currentPage + 1);
        }
    }
    const onRefreshClick = (e: any) => {
        if (props.refresh) {
            props.refresh();
        }
    }

    const onCurrentPageChange = (e: any) => {
        const newValue: number = parseInt(e.target.value);
        console.log('onCurrentPageChange-newValue', newValue)
        if (newValue > 0 && newValue < totalPages) {
            props.changePage(newValue);
        }
        // console.log('onCurrentPageChange', e)
    }

    return (
        <>
            <div className="page-navigation flex-centered flex-justify-center">
                <div className={`left-navigation flex-centered flex-space-between ${currentPage == (totalPages + 1) ? 'disabled' : ''}`}>
                    <div className="icon arrow" onClick={(e: any) => onNextClick(e)}></div>
                    <div className="icon forward desktop-only" onClick={(e: any) => onGoToLastClick(e)}></div>
                </div>
                <div className="page-info flex-centered flex-space-between">
                    <span>עמוד</span>
                    <div className="page-number">
                        <input type="number" value={currentPage} onChange={(e: any) => onCurrentPageChange(e)} />
                    </div>
                    <span>מתוך</span>
                    <span>{totalPages}</span>
                </div>
                <div className={`right-navigation flex-centered flex-space-between ${currentPage == 0 ? 'disabled' : ''}`}>
                    <div className="icon forward desktop-only" onClick={(e: any) => onGoToFirstClick(e)}></div>
                    <div className="icon arrow" onClick={(e: any) => onPrevClick(e)}></div>
                </div>
            </div>
            <div className="page-counter-data flex-centered flex-justify-center">
                <div>
                    <span>
                        מציג
                    </span>
                    <span className="start-number">
                        {start}
                    </span>
                    <span>
                        עד
                    </span>
                    <span className="last-number">
                        {end}
                    </span>
                    <span>
                        מתוך
                    </span>
                    <span className="tottal-items">
                        {props.pagerConf.totalItems}
                    </span>
                </div>
                <div className="icon refresh-counter pointer" onClick={(e: any) => onRefreshClick(e)}></div>
            </div>
        </>
    )
}

export default Pagger;